module.exports = __webpack_public_path__ + "img/11.24d83c4a.jpg";